import { create } from 'zustand';

interface MfaPendingRequest {
  /** Resolve with the MFA code to retry the original request */
  resolve: (mfaCode: string) => void;
  /** Reject to abort the original request */
  reject: (error: unknown) => void;
}

interface MfaChallengeState {
  isOpen: boolean;
  pendingRequest: MfaPendingRequest | null;
  open: (pending: MfaPendingRequest) => void;
  close: () => void;
  submit: (code: string) => void;
  cancel: () => void;
}

export const useMfaChallengeStore = create<MfaChallengeState>((set, get) => ({
  isOpen: false,
  pendingRequest: null,
  open: (pending) => set({ isOpen: true, pendingRequest: pending }),
  close: () => set({ isOpen: false, pendingRequest: null }),
  submit: (code) => {
    const { pendingRequest } = get();
    if (pendingRequest) {
      pendingRequest.resolve(code);
    }
    set({ isOpen: false, pendingRequest: null });
  },
  cancel: () => {
    const { pendingRequest } = get();
    if (pendingRequest) {
      pendingRequest.reject(new Error('MFA verification cancelled'));
    }
    set({ isOpen: false, pendingRequest: null });
  },
}));
